<template>
  <div class="maladyType">
    <div style="display:flex;justify-content: center;align-items: center;">
      <el-button round type="primary" @click="addSubject">添加病科</el-button>
      <el-button round type="success" @click="addProperty">添加病属</el-button>
    </div>

    <div class="add-subject add-subject-first">
      <h1 class="inter-line inter-line-p">病症科类</h1>
    </div>

    <!-- 病科 -->
    <HeaderSubject
      :tableData="tableData"
      :previewList="previewList"
      @previewImg="previewImg"
      @modifySubject="modifySubject"
      @deleteSub="deleteSub"
    />

    <!-- 病属/病名 -->
    <MaladyProperty
      :tableData="tableData"
      :showPro="showPro"
      @selectIndex="selectIndex"
      @modifyPro="modifyPro"
      @deletePro="deletePro"
    />

    <!-- 添加病科 -->
    <el-dialog
      :title="confirmType == 1 ? '添加病科' : '修改病科'"
      :visible.sync="dialogSubject"
    >
      <el-form :model="form" label-width="80px" label-position="top">
        <el-form-item label="病科名称 :">
          <el-input
            v-model="form.name"
            placeholder="请输入病科名称"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="上传图片 : (建议比例750:400,文件大小不得超过2MB)">
          <el-upload
            class="avatar-uploader"
            :action="uploadAction"
            :show-file-list="false"
            :data="uploadToken"
            :on-success="handleAvatarSuccess"
            :on-error="handleAvatarError"
            :before-upload="beforeAvatarUpload"
            :on-progress="handleAvatarProgress"
          >
            <img
              v-if="form.pic_path"
              :src="imgUrl + form.pic_path"
              class="avatar"
            />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogSubject = false">取 消</el-button>
        <el-button
          type="primary"
          @click="confirmSub"
          :loading="loadingUpload"
          :disabled="loadingUpload"
          >{{ loadingUpload ? "加载中" : "确认" }}</el-button
        >
      </span>
    </el-dialog>

    <!-- 添加/删除病属 -->
    <el-dialog
      :title="confirmType == 1 ? '添加病属' : '修改病属'"
      :visible.sync="dialogProperty"
    >
      <el-form :model="form" label-width="80px" label-position="top">
        <el-form-item label="请选择病科 :">
          <el-select
            v-model="form.parent_id"
            placeholder="请选择病科"
            style="width:100%;"
          >
            <el-option
              v-for="item in subjectList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="病属名称 :">
          <el-input
            v-model="form.name"
            placeholder="请输入病属名称"
            clearable
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogProperty = false">取 消</el-button>
        <el-button type="primary" @click="confirmPro">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import HeaderSubject from "./components/headerSubject";
import MaladyProperty from "./components/table";
import {
  categoryList,
  saveCategory,
  categoryDetail,
  delIllnessCategory,
} from "@/api/malady";
import imgSize from "@/utils/imgSize";
export default {
  name: "maladyType",
  data() {
    return {
      subjectList: [], // 病科列表
      tableData: [], // 表格数据
      dialogSubject: false, // 病科对话框
      confirmType: 1, // 提交类型 1:添加 2:修改
      dialogProperty: false, // 病属对话框
      form: {
        // 表单
        id: "",
        pic_path: "",
        name: "",
      },
      showPro: 0,
      previewList: [], // 图片预览列表
      uploadToken: {
        // 图片上传附带的token参数
        token: this.$store.getters.userinfo.login_token,
      },
      loadingUpload: false,
    };
  },
  components: {
    MaladyProperty, // 病属列表组件
    HeaderSubject, // 病科列表组件
  },
  created() {
    this.$store.dispatch("fullscreenLoading", true);
  },
  mounted() {
    this.getCategoryList();
  },
  methods: {
    // 获取病科,病属
    getCategoryList() {
      let list = [];
      categoryList().then(async (res) => {
        this.subjectList = [];
        for (const key in res.data.list) {
          await categoryDetail({
            id: res.data.list[key].id,
          }).then((detail) => {
            res.data.list[key].child_list = detail.data.child_list;
            list.push(res.data.list[key]);
          });
        }
        this.tableData = list;
        this.subjectList = list;
        this.$store.dispatch("fullscreenLoading", false);
      });
    },
    // 病属卡片显示隐藏
    selectIndex(index) {
      if (this.showPro === index) {
        this.showPro = -1;
      } else {
        this.showPro = index;
      }
    },
    // 删除病科
    deleteSub(item) {
      this.$confirm(
        "此操作将删除该病科,以及该病科所有的病属, 是否继续?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        delIllnessCategory({
          id: item.id,
        }).then((res) => {
          if (res.data === true) {
            this.getCategoryList();
            this.$message.success("删除成功");
          } else {
            this.$message(res.data);
          }
        });
      });
    },
    // 删除病属
    deletePro(index, item, itemPro) {
      this.$confirm("此操作将删除该病属, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        delIllnessCategory({
          id: itemPro.id,
        }).then((res) => {
          if (res.data === true) {
            this.getCategoryList();
            this.$message.success("删除成功");
          } else {
            this.$message(res.data);
          }
        });
      });
    },
    // 添加病科
    addSubject() {
      this.form = {
        id: 0,
        name: "",
        parent_id: 0,
        pic_path: "",
      };
      this.loadingUpload = false;
      this.confirmType = 1;
      this.dialogSubject = true;
    },
    // 添加病属
    addProperty() {
      this.form = {
        id: 0,
        name: "",
        parent_id: "",
      };
      this.confirmType = 1;
      this.dialogProperty = true;
    },
    // 修改病科
    modifySubject(item) {
      this.form = {
        id: item.id,
        name: item.name,
        parent_id: 0,
        pic_path: item.pic_path,
      };
      this.confirmType = 2;
      this.dialogSubject = true;
    },
    // 修改病属
    modifyPro(index, item, itemPro) {
      this.form = {
        id: itemPro.id,
        name: itemPro.name,
        parent_id: item.id,
      };
      this.confirmType = 2;
      this.dialogProperty = true;
    },
    // 图片上传成功
    handleAvatarSuccess(res) {
      this.$message.closeAll();
      this.loadingUpload = false;
      this.$message.success("上传成功");
      const { path, filename } = res.data.files[0];
      this.form.pic_path = path + filename;
    },
    // 图片上传失败
    handleAvatarError(res) {
      this.$message.closeAll();
      this.loadingUpload = false;
      this.$message.error("上传失败" + res);
    },
    // 图片正在上传
    handleAvatarProgress() {
      this.loadingUpload = true;
    },
    // 图片上传之前
    beforeAvatarUpload(file) {
      const isSize = imgSize(file, this);
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      isSize.then(() => {
        this.$message({
          showClose: true,
          duration: 0,
          message: "正在上传，请稍后...",
        });
      });
      return isLt2M && isSize;
    },
    // 提交病科信息
    confirmSub() {
      const { id, name, pic_path } = this.form;
      if (name.trim() == "") {
        this.$message.error("病科名称不能为空!");
      } else if (pic_path == "") {
        this.$message.error("病科图片不能为空!");
      } else {
        saveCategory({
          id: this.confirmType === 1 ? 0 : id, // 1:新增  id:修改
          name,
          parent_id: 0,
          pic_path,
        }).then((res) => {
          if (res.data == true) {
            this.getCategoryList();
            this.dialogSubject = false;
            this.$message.success("添加成功");
          } else {
            this.$message(res.data);
          }
        });
      }
    },
    // 确认提交病属
    confirmPro() {
      const { id, name, parent_id } = this.form;
      if (name.trim() == "" || parent_id == "") {
        this.$message.error("病科/病属名称不能为空!");
      } else {
        saveCategory({
          id: this.confirmType === 1 ? 0 : id, // 1:新增  id:修改,
          name,
          parent_id,
        }).then((res) => {
          if (res.data) {
            this.getCategoryList();
            this.dialogProperty = false;
            this.$message.success("添加成功");
          } else {
            this.$message(res.data);
          }
        });
      }
    },
    // 预览病科图片
    previewImg(url) {
      this.previewList = [`${this.imgUrl}${url}`];
    },
  },
};
</script>

<style scoped src="./style/index.css"></style>
